<div class="flex justify-content-start align-items-center">
	<h1 *ngIf="title && title != ''" class="text-white text-left">{{title}}</h1>
	<div *ngIf="api.currentUrl.indexOf('/sorties') > -1">
		<p-dropdown [options]="selectMonth" [(ngModel)]="outMonth"  styleClass="ml-4 capitalize" (onChange)="refresh()" ></p-dropdown>
	</div>
</div>
<div class="grid m-0">
	<div class="lg:col-3 transition-all transition-duration-300 col-12" *ngIf="showFilter" [ngStyle]="{paddingTop:paddingTop}">
		<div class="card surface-card p-4 mb-2 border-1 surface-border border-round-xs" >
			<span class="p-input-icon-left w-full">
				<i class="pi pi-search  text-200"></i>
				<input [(ngModel)]="filter.query" type="search" class="p-inputtext-sm w-full surface-800 text-200" pInputText placeholder="{{'Filtrer par nom, ref. ou EAN' | translate}}" (input)="dt.filterGlobal($event.target.value,'contains')">
			</span>
			<p-chip *ngFor="let chip of filter.cats" label="{{getName(chip,'cats')}}" [removable]="true" styleClass="m-1 text-xs" (onRemove)="removeChip(chip,'cats')"></p-chip>
			<p-chip *ngFor="let chip of filter.editors" label="{{getName(chip,'editors')}}" [removable]="true" styleClass="m-1 text-xs" (onRemove)="removeChip(chip,'editors')"></p-chip>
			<p-chip *ngIf="filter.player_" label="{{filter.player_}} joueur(s)" [removable]="true" styleClass="m-1 text-xs" (onRemove)="removeChip('player_','advanced')"></p-chip>
			<p-chip *ngIf="filter.age_" label="âge : {{filter.age_}}" [removable]="true" styleClass="m-1 text-xs" (onRemove)="removeChip('age_','advanced')"></p-chip>
			<p-chip *ngIf="filter.duration" label="Durée : {{filter.duration}}" [removable]="true" styleClass="m-1 text-xs" (onRemove)="removeChip('duration','advanced')"></p-chip>
		</div>
		<p-accordion [multiple]="false" styleClass="-mb-1 ">
			<p-accordionTab  header="{{ 'Catégories' | translate}}">
				<div class="transition-all transition-duration-400 transition-ease-in-out">
					<p-listbox [showToggleAll]="false" [listStyle]="{'max-height':'250px'}" [checkbox]="true" [metaKeySelection]="false" [multiple]="true" optionLabel="name" optionValue="id" [options]="api.cats" [(ngModel)]="filter.cats" (onChange)="dt.filter($event.value,'cats','arrayCompare')">
						<ng-template let-cat pTemplate="item">
							<span >{{cat.name | translate}}</span>
						</ng-template>
					</p-listbox>
				</div>
			</p-accordionTab>
			<p-accordionTab header="{{ 'Éditeurs' | translate}}">
				<div class="transition-all transition-duration-400 transition-ease-in-out">
					<p-listbox [showToggleAll]="false" [listStyle]="{'max-height':'250px'}" [checkbox]="true" [metaKeySelection]="false" [multiple]="true" optionLabel="name" optionValue="id" [options]="api.editors" [(ngModel)]="filter.editors" (onChange)="dt.filter($event.value,'editors','arrayCompare')" listStyleClass="uppercase" >
						
					</p-listbox>
				</div>
			</p-accordionTab>
			<p-accordionTab header="{{ 'Filtres avancés' | translate}}">
				<div class="transition-all transition-duration-400 transition-ease-in-out">
					<div class="mb-2" translate>nbplayers<span class="font-bold vertical-align-middle">{{filter.player_}}</span>  </div>
					<p-slider [(ngModel)]="filter.player_" [min]="0" [max]="99" (onSlideEnd)="dt.filter($event.value,'player_','betweenMinMax')"></p-slider>
				</div>
				<div class="transition-all transition-duration-400 transition-ease-in-out mt-4">
					<div class="mb-2" translate>age<span class="font-bold vertical-align-middle">{{filter.age_}}</span>  </div>
					<p-slider [(ngModel)]="filter.age_" [min]="0" [max]="99" (onSlideEnd)="dt.filter($event.value,'age_','betweenMinMax')"></p-slider>
				</div>

				<div class="transition-all transition-duration-400 transition-ease-in-out mt-4">
					<div class="mb-2" translate>duration</div>
					<p-dropdown [options]="durations" [(ngModel)]="filter.duration" placeholder="{{'Choisir une durée' | translate}}" (onChange)="dt.filter($event.value,'duration','betweenMinMax')"></p-dropdown>
				</div>
			</p-accordionTab>
			<p-accordionTab header="Disponibilités" *ngIf="!api.export">
				<div class="transition-all transition-duration-400 transition-ease-in-out">
					<p>
						<p-checkbox [trueValue]="true" [falseValue]="null" [binary]="true" [(ngModel)]="filter.orderable" label="Disponible" (onChange)="dt.filter($event.checked,'orderable','equals')"></p-checkbox>
					</p>
					<p>
						<p-checkbox [trueValue]="true" [falseValue]="null" [binary]="true" [(ngModel)]="filter.rupture" label="En rupture" (onChange)="dt.filter($event.checked,'rupture','equals')"></p-checkbox>
					</p>
					<p>
						<p-checkbox [trueValue]="'1'" [falseValue]="null" [binary]="true" [(ngModel)]="filter.coming" label="À paraître" (onChange)="dt.filter($event.checked,'coming','equals')"></p-checkbox>
					</p>

				</div>
			</p-accordionTab>
		</p-accordion>
	</div>
	<div class="{{showFilter ? 'lg:col-9' : 'lg:col-12'}} grid m-0 col-12" >
		<p-table #dt [value]="activeGames" [globalFilterFields]="['name_item','BarCode','Id','name']" (onFilter)="onFilter($event)"></p-table>
		<p-dataView [first]="first" [paginator]="true" [rows]="96" (onPage)="first = $event.first" [ngStyle]="{width: '100%'}" #dv [value]="games" [sortField]="sortField" [sortOrder]="sortOrder" layout="grid">
			<ng-template pTemplate="header">
				<div class="flex flex-column md:flex-row md:justify-content-between">
					<div class="flex flex-row justify-content-start" *ngIf="showSort">
						<p-dropdown [options]="sortByMenu" [(ngModel)]="sortField"  styleClass="mb-2 md:mb-0 p-0 ">
							<ng-template let-item pTemplate="item">
								<span>{{item.label | translate}}</span>
							</ng-template>
							<ng-template let-item pTemplate="selectedItem">
								<span>{{item.label | translate}}</span>
							</ng-template>
						</p-dropdown>
						<p-selectButton styleClass="p-selectButton" optionLabel="icon" [options]="[{icon:'pi pi-sort-amount-down-alt',value:1},{icon:'pi pi-sort-amount-down',value:-1}]" [(ngModel)]="sortOrder" optionValue="value">
							<ng-template let-item>
								<i [class]="item.icon"></i>
							</ng-template>
						</p-selectButton>
					</div>
					<div style="padding: 0.6rem">{{dv.totalRecords}} références</div>
					<p-dataViewLayoutOptions></p-dataViewLayoutOptions>
				</div>
			</ng-template>
			<ng-template let-game pTemplate="listItem">
				<div class="col-12 "> 
					<app-bloc-game [game]="game" [view]="'listView'"></app-bloc-game>
				</div>
			</ng-template>
			<ng-template let-game pTemplate="gridItem">

				<div class="col-12 sm:col-6 {{showFilter ? 'md:col-4' : 'md:col-3'}} {{load ? 'hidden' : ''}}" >
					<app-bloc-game [game]="game" [view]="'gridView'"></app-bloc-game>
				</div>
			</ng-template>
		</p-dataView>
	</div>
</div>
<ng-template #loading>
	<div>
		<p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
	</div>
</ng-template>